export const MAIN_CONTENT_ID = "main-content";
export const CUSTOMER_CONTENT_ID = "customer-content";
